// @ts-nocheck
import React, { useCallback } from 'react';
import { compose } from '@/utils';
import { DataTable, TableSkeletonRows } from '@/components';
import { useShippingAccountsContext } from './ShippingAccountsProvider';
import { ActionMenuList, useShippingAccountsTableColumns } from './ShippingAccountsComponent';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import withAlertActions from '@/containers/Alert/withAlertActions';

function ShippingAccountsDataTable({ tableProps, openDialog, openAlert }) {
  const { shippingAccounts = [], isShippingAccountsLoading } =
    useShippingAccountsContext();

  const columns = useShippingAccountsTableColumns();

  const handleEdit = useCallback(
    (account) => {
      openDialog('shipping-account-form', {
        action: 'edit',
        shippingAccountId: account.id,
      });
    },
    [openDialog],
  );

  const handleDelete = (account) => {
    openAlert('shipping-account-delete', { shippingAccountId: account.id });
  };

  return (
    <DataTable
      columns={columns}
      data={shippingAccounts}
      loading={isShippingAccountsLoading}
      headerLoading={isShippingAccountsLoading}
      progressBarLoading={isShippingAccountsLoading}
      TableLoadingRenderer={TableSkeletonRows}
      ContextMenu={ActionMenuList}
      noInitialFetch={true}
      payload={{
        onEditShippingAccount: handleEdit,
        onDeleteShippingAccount: handleDelete,
      }}
      rowContextMenu={ActionMenuList}
      {...tableProps}
    />
  );
}

export default compose(withDialogActions, withAlertActions)(ShippingAccountsDataTable);